<script>
  /* Copyright (c) 2020 Jacques Desodt */
  export let args = null
  export let label = null
</script>

<div
  role="button"
  tabindex="0"
  class="_tp-button {args.buttonClassName}"
  on:click|stopPropagation
  on:keypress={e => {
    if (e.key === 'Enter') {
      e.stopPropagation()
    }
  }}
>
  {@html label}
</div>

<style>
  ._tp-button {
    background-color: #fff;
    border-radius: 0.25rem;
    color: #666;
    cursor: pointer;
    font-size: 1rem;
    min-width: 4rem;
    padding: 0.5rem;
    text-align: center;
    transition-duration: 300ms;
    transition-property: all;
  }
  ._tp-button:hover {
    background-color: #666;
    color: #fff;
  }
</style>
